import { parse } from "graphql";
import { SchemaClient } from "../../../common/GraphqlClient";
import { SchemaClientKinds, Source } from "../../../common/Source";
import { EMPTY_VALUE } from "../../../Schema";
import { uniqueSortedLabels } from "./filterValues";

/** One distinct `contactPerson` value in use, from `instrumentFilterValues`. */
export type ContactPerson = {
  filterValue: string;
};

/**
 * Contact persons, read from the OpenSearch-backed `instrumentFilterValues` query, as `Tags.ts`
 * does, for the `contactPerson` attribute.
 *
 * GraphQL only; see {@link getContactPersons}.
 */
const listContactPersons: Source<ContactPerson[]> = {
  graphql: parse(`
    query instrumentFilterValues($nextToken: String) {
      instrumentFilterValues(
        filterAttribute: "contactPerson",
        nextToken: $nextToken
      ) {
        nextToken
        items {
          filterValue
        }
      }
    }
  `),
};

/**
 * Contact person filter options.
 *
 * Answers `[]` for any client that is not GraphQL.
 * Safe as a stub because these values only populate a grid filter dropdown and never reach
 * `DataManager`.
 *
 * @param client - Read client for the master data.
 * @returns Contact persons names, deduplicated and sorted.
 */
export const getContactPersons = async (client: SchemaClient): Promise<string[]> => {
  if (client.kind !== SchemaClientKinds.GRAPHQL) {
    console.warn("getContactPersons: client is not GraphQL, returning empty list!");
    return [];
  }
  const contactPersons = await client.queryList(listContactPersons);
  const items = contactPersons === EMPTY_VALUE ? [] : contactPersons ?? [];
  return uniqueSortedLabels(items.map((contactPerson) => contactPerson.filterValue));
};
